import React, { useState } from 'react';

function DismissedTab({ employees, onBack, onEmployeeClick, onRestore }) {
  const [search, setSearch] = useState('');

  const getInitials = (fullName) => {
    if (!fullName) return '?';
    const parts = fullName.trim().split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

  const formatDate = (d) => {
    if (!d) return '—';
    return new Date(d).toLocaleDateString('ru-RU');
  };

  // Фильтрация по поиску
  const filtered = employees.filter((emp) => {
    if (!search) return true;
    const s = search.toLowerCase();
    return (
      (emp.full_name || '').toLowerCase().includes(s) ||
      (emp.tab_number || '').toLowerCase().includes(s) ||
      (emp.phone || '').toLowerCase().includes(s)
    );
  });

  return (
    <div className="app">
      <header className="header no-print">
        <h1>📁 Уволенные сотрудники</h1>
        <button className="btn-back" onClick={onBack}>← Назад</button>
      </header>

      {/* ПОИСК */}
      <div className="filters no-print">
        <input
          type="text"
          className="filter-search"
          placeholder="🔍 Поиск по ФИО, табельному, телефону..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        {search && (
          <button className="btn-clear" onClick={() => setSearch('')}>
            ✖ Сбросить
          </button>
        )}
      </div>

      <div className="group">
        <div className="group-title">
          Уволенные <span className="count">{filtered.length}</span>
        </div>

        {filtered.length === 0 ? (
          <div className="empty">
            {search ? 'Никого не найдено по запросу' : 'Нет уволенных сотрудников'}
          </div>
        ) : (
          
                    <table className="table">
            <thead>
              <tr>
                <th className="col-tab">Табель</th>
                <th>ФИО</th>
                <th style={{ width: '120px' }}>Дата увольнения</th>
                <th>Комментарий</th>
                <th style={{ width: '120px' }}></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((emp) => (
                <tr key={emp.id}>
                  <td
                    className="col-tab-value"
                    onClick={() => onEmployeeClick(emp)}
                    style={{ cursor: 'pointer' }}
                  >
                    {emp.tab_number || '—'}
                  </td>
                  <td
                    className="emp-name"
                    onClick={() => onEmployeeClick(emp)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="emp-name-cell">
                      <div className={`emp-avatar ${emp.gender === 'м' ? 'male' : 'female'}`}>
                        {getInitials(emp.full_name)}
                      </div>
                      {emp.full_name}
                    </div>
                  </td>
                  <td onClick={() => onEmployeeClick(emp)} style={{ cursor: 'pointer' }}>
                    <span className="badge badge-dismissed">
                      {formatDate(emp.dismissal_date)}
                    </span>
                  </td>
                  <td
                    onClick={() => onEmployeeClick(emp)}
                    style={{ cursor: 'pointer', fontSize: '12px', color: '#6c757d' }}
                  >
                    {emp.comment || '—'}
                  </td>
                  <td>
                    <button
                      className="btn-restore"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (window.confirm(`Вернуть сотрудника "${emp.full_name}" в общий список?`)) {
                          onRestore(emp);
                        }
                      }}
                      title="Вернуть в общий список"
                    >
                      ↩️ Вернуть
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default DismissedTab;